import NavbarComponent from "../components/Navbar"
import GreekLine from "../components/GreekLine"
import { Link, useLocation, useNavigate } from "react-router-dom";
import SEO from "@/components/SEO"
import { useEffect } from "react"

const NotFoundPage = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (location.pathname !== "/page-not-found") {
      navigate("/page-not-found", { replace: true })
    }
  }, [location.pathname, navigate])

  return (
    <>
      <SEO titleOverride="Page Not Found" />
      <NavbarComponent bgColor="bg-white" />
      <section className="bg-[url('/src/assets/imgs/di-sana/slide-07.jpg')] h-[50vh] w-full bg-cover relative">
        <GreekLine custCls="bottom-0 absolute w-full" />
      </section>
      <div className="px-5 sm:px-10 py-6 sm:py-8">
        <h1 className="font-sloopScriptPro text-6xl sm:text-8xl text-[#95702e] font-bold mb-3">Page not found</h1>
        <p className="text-charcoal-black text-base sm:text-2xl font-light font-agcasmlt sm:w-1/2 lg:w-[35%] inline-block mb-6">The page you're looking for may not be exist.<Link to="/" className="text-[#95702e]"> Go to homepage</Link>.</p>
      </div>
    </>
  )
}

export default NotFoundPage